module.exports = __webpack_public_path__ + "img/big_chip_bg.b65a1e1d.svg";